import instance from '@/api/index.js'
const urlPrefix = '/v1/'
export default {
    doLogin (params) {
        return instance({
            method: 'post',
            url: `${urlPrefix}user/login`,
            data: params
        })
    },
    resetPassword (id, params) {
        return instance({
            method: 'post',
            url: `${urlPrefix}user/${id}/change-password`,
            data: params
        })
    },
    //模糊搜索用户
    getUserBySearch (params){
        return instance({
            method: 'get',
            url: `${urlPrefix}user/search`,
            params: params
        })
    },
    getUsers(params) {
        return instance({
            method: 'get',
            params: params,
            url: `${urlPrefix}user/list`,
        })
    },
    getUserInfo() {
        return instance({
            method: 'get',
            url: `${urlPrefix}user/info`,
        })
    }
}
